import { CheckoutFlowBase } from './checkout-flow-base';

export interface SubscriptionManagement extends CheckoutFlowBase {
  type: 'SUBSCRIPTION_MANAGEMENT';
}
